/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

export const StoragePrefix = '';

export enum StorageTokens {
  USERNAME = 'Username',
  TOKEN = 'Token',
  REFRESH_TOKEN = 'RefreshToken',
  REMEMBER_SESSION = 'RememberSession',
  IS_MANAGER = 'IsManager',
  SELECTED_GROUP = 'SelectedGroup',
  SELECTED_GROUP_NAME = 'SelectedGroupName',
  SELECTED_WORKSHOP_NAME = 'SelectedWorkshopName',
  SELECTED_WORKSHOP = 'SelectedWorkshop',
  SELECTED_SEASON = 'SelectedSeason',
  SELECTED_PACKING_NUMBER = 'PackingNumber',
  SELECTED_PACKING_NUMBER_STATUS = 'PackingNumberStatus',
}
